module.exports = __webpack_public_path__ + "6c4a0dbc/img/pwrd-by-sourcery-black.bba9ba41.svg";